import React from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

function ContactDetail() {
  return (
    <Card
      elevation={0}
      sx={{
        backgroundColor: "tertiary.yellow.light",
        borderRadius: 4,
        padding: 1,
      }}
    >
      <CardContent>
        <Stack alignItems="center" width="100%" spacing={2}>
          <Stack>
            <Typography
              variant="h6"
              color="common.white"
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Cơ sở 1
            </Typography>
            <Typography variant="body1" color="common.white" align="center">
              <div>
                <div>400 Lê Hồng Phong, Chiêu Liêu, Dĩ An</div>
                <div>(đối diện lẩu dê Dũng Mập 2)</div>
              </div>
            </Typography>
          </Stack>

          <Stack>
            <Typography
              variant="h6"
              color="common.white"
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Cơ sở 2
            </Typography>
            <Typography variant="body1" color="common.white" align="center">
              <div>
                <div>Tòa nhà Bcons Tower VI, đường số 3 Thống Nhất</div>
                <div>(kế bên nhà thuốc Minh Châu 5-số 112 Nguyễn Trãi)</div>
              </div>
            </Typography>
          </Stack>

          <Stack>
            <Typography
              variant="h6"
              color="common.white"
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Cơ sở 3
            </Typography>
            <Typography variant="body1" color="common.white" align="center">
              <div>
                <div> 88 Nguyễn Trãi - Lầu 2, Nhà sách Hoàng Phúc</div>
                <div>(cách trường TH Lý Thường Kiệt 200m)</div>
              </div>
            </Typography>
          </Stack>

          <Stack>
            <Typography
              variant="h6"
              color="common.white"
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Hotline hệ thống
            </Typography>
            <Typography variant="body1" color="common.white" align="center">
              0966 766 839
            </Typography>
          </Stack>

          <Stack>
            <Typography
              variant="h6"
              color="common.white"
              align="center"
              sx={{ fontWeight: "bold" }}
            >
              Email
            </Typography>
            <Typography variant="body1" color="common.white" align="center">
              theenglishtree.edu@gmail.com
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

function ContactDetails() {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      useFlexGap
      flexWrap="wrap"
      spacing={2}
    >
      <ContactDetail />
    </Stack>
  );
}

export default ContactDetails;
